import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem("token")) return setLoading(false);
    api.get("/auth/me").then((r) => { setUser(r.data); localStorage.setItem("uid", r.data.id); }).catch(() => localStorage.removeItem("token")).finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => { api.get("/auth/me").catch((e) => { if (e?.response?.status === 401) { localStorage.removeItem("token"); setUser(null); } }); }, 60000);
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("uid", data.user.id);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("token"); setUser(null); };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
